import React from 'react';

import {useUnit} from 'effector-react';

import {useTranslation} from 'react-i18next';

import {INSPECTOR_ROLES, TAXPAYER_ROLES} from '@/entities/user/permissions';
import {PermissionAccess} from '@/features/PermissionAccess';
import {PageHeader} from '@/widgets/PageHeader';
import {ROUTES} from '@app/routing';
import {userModel} from '@entities/user/model';
import {Value, ValueWrapper, Wrapper} from '@pages/Profile/styled';
import {history} from '@shared/lib/history';
import {Button, ButtonVariant} from '@shared/ui/Button';
import {Page} from '@shared/ui/Page';
import {Switch} from '@shared/ui/Switcher';
import {Title} from '@shared/ui/Title';
import {handleNil} from '@utils/handleNil';

export const Profile = () => {
    const {t} = useTranslation();
    const user = useUnit(userModel);

    return (
        <Page>
            <Wrapper>
                <PageHeader title={t('page_profile.title')}>
                    <Button
                        style={{marginLeft: 'auto', width: 'fit-content'}}
                        variant={ButtonVariant.Outline}
                        onClick={() => history.push(ROUTES.CHANGE_PASSWORD)}
                    >
                        {t('page_profile.control.change_password')}
                    </Button>
                </PageHeader>
                <PermissionAccess roles={TAXPAYER_ROLES}>
                    <ValueWrapper>
                        <Title size={4}>{t('page_profile.company.title')}</Title>
                        <div>
                            <Value>
                                <h3>{t('page_profile.company.fields.name')}</h3>
                                <span>{handleNil(user.state.profile?.company.name)}</span>
                            </Value>
                            <Value>
                                <h3>{t('page_profile.company.fields.address')}</h3>
                                <span>{handleNil(user.state.address)}</span>
                            </Value>
                            <Value>
                                <h3>{t('page_profile.company.fields.department')}</h3>
                                <span>
                                    {handleNil(user.state.profile?.company.department?.name)}
                                </span>
                            </Value>
                            <Value>
                                <h3>{t('page_profile.company.fields.tin')}</h3>
                                <span>{handleNil(user.state.profile?.company.tin)}</span>
                            </Value>
                            <Value>
                                <h3>{t('page_profile.company.fields.email')}</h3>
                                <span>{handleNil(user.state.profile?.company.email)}</span>
                            </Value>
                        </div>
                    </ValueWrapper>
                </PermissionAccess>

                <ValueWrapper>
                    <PermissionAccess roles={TAXPAYER_ROLES}>
                        <Title size={4}>{t('page_profile.director.title')}</Title>
                    </PermissionAccess>
                    <div>
                        <Value>
                            <h3>{t('page_profile.director.fields.name')}</h3>
                            <span>{handleNil(user.state.name)}</span>
                        </Value>
                        <Value>
                            <h3>{t('page_profile.director.fields.email')}</h3>
                            <span>{handleNil(user.state.profile?.email)}</span>
                        </Value>
                        <Value>
                            <h3>{t('page_profile.director.fields.phone')}</h3>
                            <span>{handleNil(user.state.profile?.phone)}</span>
                        </Value>
                        <PermissionAccess roles={INSPECTOR_ROLES}>
                            <Value>
                                <h3>{t('page_profile.company.fields.department')}</h3>
                                <span>
                                    {handleNil(user.state.profile?.company.department?.name)}
                                </span>
                            </Value>
                        </PermissionAccess>
                    </div>
                </ValueWrapper>
                <PermissionAccess roles={TAXPAYER_ROLES}>
                    <ValueWrapper>
                        <Switch
                            width="300px"
                            defaultVal={!!user.state.profile?.company.peppolSendingEnabled}
                            label={t('page_profile.peppol')}
                        />
                    </ValueWrapper>
                </PermissionAccess>
            </Wrapper>
        </Page>
    );
};
